<script lang="ts" setup>
import type { SectionsCustomHeading } from '@autobid/strapi-integration/rest/components'
import { customHeading } from '@autobid/ui/utils/cva/customHeadingCva'

interface Props {
  data: SectionsCustomHeading
}

defineProps<Props>()
</script>

<template>
  <div :id="data.anchor" class="prose max-w-none px-3 xl:pl-0">
    <component
      :is="data.elementTag?.name || 'p'"
      :class="[customHeading({ alignment: data.alignment?.name })]"
    >
      {{ data.title }}
    </component>
  </div>
</template>
